import types from './types'

/**
 * Setea información de las sincronizacion para chatmail
 * @returns
 */
const updateChatmailSync = (data = {}, isNew = false) => (dispatch, getState) => {
  const { channels: { chatmailSync } } = getState()
  
  const _chatmailSync = isNew ? data : chatmailSync.concat(data)

  dispatch({ type: types.UPDATE_CHATMAIL_SYNC, chatmailSync: _chatmailSync })

}

export default {
  updateChatmailSync,
}